import React from 'react'
import { Button } from '../../../..'
import { FormattedMessage } from 'react-intl'

import styles from './Buttons.module.scss'

const ContinueButton = () => {
  return (
    <Button primary fullWidth className={styles.continue} type='submit'>
      <FormattedMessage id='Button.Continue' defaultMessage='Continue' />
    </Button>
  )
}

export default ContinueButton
